export const ANALYTICS_SUITE_IDS = {
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service',
  COMMERCE: 'commerce',
  DISCOVER: 'discover'
};
export const REVENUE_SUB_APP = 'revenue';
export const salesAnalyticsBasedCollections = [ANALYTICS_SUITE_IDS.MARKETING, ANALYTICS_SUITE_IDS.SALES, ANALYTICS_SUITE_IDS.SERVICE, ANALYTICS_SUITE_IDS.COMMERCE];